import { render, staticRenderFns } from "./CompletedProjectSection.vue?vue&type=template&id=98827ce2&scoped=true"
import script from "./CompletedProjectSection.vue?vue&type=script&lang=js"
export * from "./CompletedProjectSection.vue?vue&type=script&lang=js"
import style0 from "./CompletedProjectSection.vue?vue&type=style&index=0&id=98827ce2&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98827ce2",
  null
  
)

export default component.exports